var cov_1l2ymofm7m = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Picker.tsx",
      hash = "6e39a4b0cad0948b8860c736eb9fa5f03d577b16",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Picker.tsx",
    statementMap: {
      "0": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 16
        }
      },
      "1": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 45,
          column: 5
        }
      },
      "2": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 21
        }
      },
      "3": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 13
        }
      },
      "4": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 22
        }
      },
      "5": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 13
        }
      },
      "6": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 24
        }
      },
      "7": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 13
        }
      },
      "8": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 21
        }
      },
      "9": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 13
        }
      },
      "10": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 20
        }
      },
      "11": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 25
        }
      },
      "12": {
        start: {
          line: 48,
          column: 19
        },
        end: {
          line: 48,
          column: 40
        }
      },
      "13": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 60,
          column: 5
        }
      },
      "14": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 60
        }
      },
      "15": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 56
        }
      },
      "16": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 57
        }
      },
      "17": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 50
        }
      },
      "18": {
        start: {
          line: 68,
          column: 25
        },
        end: {
          line: 68,
          column: 35
        }
      },
      "19": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 63
        }
      },
      "20": {
        start: {
          line: 73,
          column: 25
        },
        end: {
          line: 73,
          column: 35
        }
      },
      "21": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 94
        }
      },
      "22": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 23
        }
      },
      "23": {
        start: {
          line: 81,
          column: 35
        },
        end: {
          line: 81,
          column: 45
        }
      },
      "24": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 71
        }
      },
      "25": {
        start: {
          line: 82,
          column: 44
        },
        end: {
          line: 82,
          column: 71
        }
      },
      "26": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 88,
          column: 10
        }
      },
      "27": {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 87,
          column: 29
        }
      },
      "28": {
        start: {
          line: 92,
          column: 21
        },
        end: {
          line: 92,
          column: 31
        }
      },
      "29": {
        start: {
          line: 93,
          column: 46
        },
        end: {
          line: 93,
          column: 56
        }
      },
      "30": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 111,
          column: 5
        }
      },
      "31": {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 98,
          column: 21
        }
      },
      "32": {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 99,
          column: 13
        }
      },
      "33": {
        start: {
          line: 101,
          column: 8
        },
        end: {
          line: 101,
          column: 22
        }
      },
      "34": {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 102,
          column: 13
        }
      },
      "35": {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 104,
          column: 21
        }
      },
      "36": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 105,
          column: 13
        }
      },
      "37": {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 107,
          column: 24
        }
      },
      "38": {
        start: {
          line: 108,
          column: 8
        },
        end: {
          line: 108,
          column: 13
        }
      },
      "39": {
        start: {
          line: 110,
          column: 8
        },
        end: {
          line: 110,
          column: 20
        }
      },
      "40": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 123,
          column: 7
        }
      },
      "41": {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 123,
          column: 7
        }
      },
      "42": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 133,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        loc: {
          start: {
            line: 26,
            column: 34
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 26
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        },
        loc: {
          start: {
            line: 67,
            column: 15
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 67
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 72,
            column: 3
          }
        },
        loc: {
          start: {
            line: 72,
            column: 38
          },
          end: {
            line: 75,
            column: 3
          }
        },
        line: 72
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 77,
            column: 3
          }
        },
        loc: {
          start: {
            line: 77,
            column: 42
          },
          end: {
            line: 83,
            column: 3
          }
        },
        line: 77
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 85,
            column: 3
          }
        },
        loc: {
          start: {
            line: 85,
            column: 31
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 85
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 86,
            column: 15
          },
          end: {
            line: 86,
            column: 16
          }
        },
        loc: {
          start: {
            line: 86,
            column: 21
          },
          end: {
            line: 88,
            column: 5
          }
        },
        line: 86
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 11
          },
          end: {
            line: 134,
            column: 3
          }
        },
        line: 91
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 33,
            column: 13
          }
        }, {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 36,
            column: 13
          }
        }, {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 39,
            column: 13
          }
        }, {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 42,
            column: 13
          }
        }, {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 44,
            column: 20
          }
        }],
        line: 30
      },
      "1": {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 71
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 71
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 71
          }
        }],
        line: 82
      },
      "2": {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 19
          }
        }, {
          start: {
            line: 82,
            column: 23
          },
          end: {
            line: 82,
            column: 42
          }
        }],
        line: 82
      },
      "3": {
        loc: {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 111,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 97,
            column: 6
          },
          end: {
            line: 99,
            column: 13
          }
        }, {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 102,
            column: 13
          }
        }, {
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 105,
            column: 13
          }
        }, {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 108,
            column: 13
          }
        }, {
          start: {
            line: 109,
            column: 6
          },
          end: {
            line: 110,
            column: 20
          }
        }],
        line: 96
      },
      "4": {
        loc: {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 123,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 123,
            column: 7
          }
        }, {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 123,
            column: 7
          }
        }],
        line: 113
      },
      "5": {
        loc: {
          start: {
            line: 116,
            column: 42
          },
          end: {
            line: 116,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 42
          },
          end: {
            line: 116,
            column: 49
          }
        }, {
          start: {
            line: 116,
            column: 53
          },
          end: {
            line: 116,
            column: 72
          }
        }],
        line: 116
      },
      "6": {
        loc: {
          start: {
            line: 119,
            column: 22
          },
          end: {
            line: 119,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 22
          },
          end: {
            line: 119,
            column: 29
          }
        }, {
          start: {
            line: 119,
            column: 33
          },
          end: {
            line: 119,
            column: 52
          }
        }],
        line: 119
      },
      "7": {
        loc: {
          start: {
            line: 129,
            column: 20
          },
          end: {
            line: 129,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 129,
            column: 20
          },
          end: {
            line: 129,
            column: 27
          }
        }, {
          start: {
            line: 129,
            column: 31
          },
          end: {
            line: 129,
            column: 50
          }
        }],
        line: 129
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Picker.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import Day from './Day';
import Time from './Time';
import Year from './Year';
import Month from './Month';
import utils from './utils';
import Quick from './Quick';
import Quarter from './Quarter';
import paramUtils from './paramUtils';
import { getLocale } from '../locale';
import { datepickerClass } from './styles';
import { PureComponent } from '../component';

var Picker =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Picker, _PureComponent);

  var _super = _createSuper2(Picker);

  function Picker(props) {
    var _this;

    _classCallCheck(this, Picker);

    cov_1l2ymofm7m.f[0]++;
    cov_1l2ymofm7m.s[0]++;
    _this = _super.call(this, props);
    _this.defaultCurrent = void 0;
    _this.handleEnter = void 0;
    _this.handleLeave = void 0;
    var mode;
    cov_1l2ymofm7m.s[1]++;

    switch (props.type) {
      case 'year':
        cov_1l2ymofm7m.b[0][0]++;
        cov_1l2ymofm7m.s[2]++;
        mode = 'year';
        cov_1l2ymofm7m.s[3]++;
        break;

      case 'month':
        cov_1l2ymofm7m.b[0][1]++;
        cov_1l2ymofm7m.s[4]++;
        mode = 'month';
        cov_1l2ymofm7m.s[5]++;
        break;

      case 'quarter':
        cov_1l2ymofm7m.b[0][2]++;
        cov_1l2ymofm7m.s[6]++;
        mode = 'quarter';
        cov_1l2ymofm7m.s[7]++;
        break;

      case 'time':
        cov_1l2ymofm7m.b[0][3]++;
        cov_1l2ymofm7m.s[8]++;
        mode = 'time';
        cov_1l2ymofm7m.s[9]++;
        break;

      default:
        cov_1l2ymofm7m.b[0][4]++;
        cov_1l2ymofm7m.s[10]++;
        mode = 'day';
    }

    cov_1l2ymofm7m.s[11]++;
    _this.state = {
      mode: mode
    };
    var format = (cov_1l2ymofm7m.s[12]++, 'YYYY-MM-DD HH:mm:ss');
    cov_1l2ymofm7m.s[13]++;
    _this.defaultCurrent = utils.toDateWithFormat(utils.formatDateWithDefaultTime(utils.newDate(undefined, _this.getOptions()), undefined, props.defaultTime[0], format, _this.getOptions()), format, undefined, _this.getOptions());
    cov_1l2ymofm7m.s[14]++;
    _this.handleModeChange = _this.handleModeChange.bind(_assertThisInitialized(_this));
    cov_1l2ymofm7m.s[15]++;
    _this.handleEnter = _this.handleMouse.bind(_assertThisInitialized(_this), true);
    cov_1l2ymofm7m.s[16]++;
    _this.handleLeave = _this.handleMouse.bind(_assertThisInitialized(_this), false);
    cov_1l2ymofm7m.s[17]++;
    _this.handleQuick = _this.handleQuick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Picker, [{
    key: "getOptions",
    value: function getOptions() {
      cov_1l2ymofm7m.f[1]++;

      var _ref = (cov_1l2ymofm7m.s[18]++, this.props),
          timeZone = _ref.timeZone;

      cov_1l2ymofm7m.s[19]++;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "handleQuick",
    value: function handleQuick(quick) {
      cov_1l2ymofm7m.f[2]++;

      var _ref2 = (cov_1l2ymofm7m.s[20]++, this.props),
          onChange = _ref2.onChange;

      cov_1l2ymofm7m.s[21]++;
      onChange.apply(void 0, _toConsumableArray(paramUtils.quickHandleChangeParams(quick.value[0], true, false, false, quick)));
    }
  }, {
    key: "handleMouse",
    value: function handleMouse(isEnter, e) {
      cov_1l2ymofm7m.f[3]++;
      cov_1l2ymofm7m.s[22]++;
      // stop
      e.stopPropagation();

      var _ref3 = (cov_1l2ymofm7m.s[23]++, this.props),
          index = _ref3.index,
          handleHover = _ref3.handleHover;

      cov_1l2ymofm7m.s[24]++;

      if ((cov_1l2ymofm7m.b[2][0]++, handleHover) && (cov_1l2ymofm7m.b[2][1]++, index !== undefined)) {
        cov_1l2ymofm7m.b[1][0]++;
        cov_1l2ymofm7m.s[25]++;
        handleHover(index, isEnter);
      } else {
        cov_1l2ymofm7m.b[1][1]++;
      }
    }
  }, {
    key: "handleModeChange",
    value: function handleModeChange(mode) {
      var _this2 = this;

      cov_1l2ymofm7m.f[4]++;
      cov_1l2ymofm7m.s[26]++;
      setTimeout(function () {
        cov_1l2ymofm7m.f[5]++;
        cov_1l2ymofm7m.s[27]++;

        _this2.setState({
          mode: mode
        });
      }, 10);
    }
  }, {
    key: "render",
    value: function render() {
      cov_1l2ymofm7m.f[6]++;

      var _ref4 = (cov_1l2ymofm7m.s[28]++, this.state),
          mode = _ref4.mode;

      var _ref5 = (cov_1l2ymofm7m.s[29]++, this.props),
          current = _ref5.current,
          index = _ref5.index,
          otherProps = _objectWithoutProperties(_ref5, ["current", "index"]);

      var Render;
      cov_1l2ymofm7m.s[30]++;

      switch (mode) {
        case 'year':
          cov_1l2ymofm7m.b[3][0]++;
          cov_1l2ymofm7m.s[31]++;
          Render = Year;
          cov_1l2ymofm7m.s[32]++;
          break;

        case 'month':
          cov_1l2ymofm7m.b[3][1]++;
          cov_1l2ymofm7m.s[33]++;
          Render = Month;
          cov_1l2ymofm7m.s[34]++;
          break;

        case 'time':
          cov_1l2ymofm7m.b[3][2]++;
          cov_1l2ymofm7m.s[35]++;
          Render = Time;
          cov_1l2ymofm7m.s[36]++;
          break;

        case 'quarter':
          cov_1l2ymofm7m.b[3][3]++;
          cov_1l2ymofm7m.s[37]++;
          Render = Quarter;
          cov_1l2ymofm7m.s[38]++;
          break;

        default:
          cov_1l2ymofm7m.b[3][4]++;
          cov_1l2ymofm7m.s[39]++;
          Render = Day;
      } // only range has index prop


      cov_1l2ymofm7m.s[40]++;

      if (index === undefined) {
        cov_1l2ymofm7m.b[4][0]++;
        cov_1l2ymofm7m.s[41]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: datepickerClass('split'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 115,
              columnNumber: 9
            }
          },
          /*#__PURE__*/
          React.createElement(Quick, Object.assign({}, otherProps, {
            current: (cov_1l2ymofm7m.b[5][0]++, current) || (cov_1l2ymofm7m.b[5][1]++, this.defaultCurrent),
            onChange: this.handleQuick,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 116,
              columnNumber: 11
            }
          })),
          /*#__PURE__*/
          React.createElement(Render, Object.assign({}, otherProps, {
            current: (cov_1l2ymofm7m.b[6][0]++, current) || (cov_1l2ymofm7m.b[6][1]++, this.defaultCurrent),
            onModeChange: this.handleModeChange,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 117,
              columnNumber: 11
            }
          })))
        );
      } else {
        cov_1l2ymofm7m.b[4][1]++;
      }

      cov_1l2ymofm7m.s[42]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          onMouseEnter: this.handleEnter,
          onMouseLeave: this.handleLeave,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 125,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Render, Object.assign({}, otherProps, {
          index: index,
          current: (cov_1l2ymofm7m.b[7][0]++, current) || (cov_1l2ymofm7m.b[7][1]++, this.defaultCurrent),
          onModeChange: this.handleModeChange,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 126,
            columnNumber: 9
          }
        })))
      );
    }
  }]);

  return Picker;
}(PureComponent);

export default Picker;